import {Component} from "react"
import DivLeftAlign from "../Styled/DivLeftAlign.jsx"
import PropTypes from "prop-types"
import Date from "../Moment/Date.jsx"

import './InterviewNote.scss'
import {isArray} from "validate.js"

export class InterviewNote extends Component {
  static propTypes = {
    conf:  PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
  }

  getFreelancePermit = (worksPermit) => {
    if(!worksPermit && worksPermit !== 0){
      return ''
    }

    const permits = this.props.conf.workPermits
    if(!permits) {
      return ''
    }

    const permitsArray = Object.values(permits)
    const found = permitsArray.find((permit) => {
      return permit.value === worksPermit
    })

    if(!found || !found.label) {
      return ''
    }

    return found.label
  }

  getFreelanceSituation = (situation) => {
    if (!situation && situation !== 0) {
      return ''
    }

    const situations = this.props.conf.situations
    if(!situations) {
      return ''
    }

    const situationsArray = Object.values(situations)
    const found = situationsArray.find((situationItem) => {
      return situationItem.value === situation
    })

    if(!found || !found.label) {
      return ''
    }

    return found.label
  }

  getNoteData = () => {
    const {user, freelance} = this.props
    const initialInterviewData = freelance && freelance.initial_interview_data ? freelance.initial_interview_data: {}

    const userWorkCities = (user.work_cities && isArray(user.work_cities))
      ? user.work_cities.map((workCity) => workCity.name).join(', ')
      : ''

    return {
      dateAvailable: initialInterviewData.date_available
        ? (initialInterviewData.date_available?.date ?? null
          ? initialInterviewData.date_available?.date ?? null
          : initialInterviewData?.date_available ?? null)
        : freelance?.date_available ?? null,
      dateAvailableTunnelComment: initialInterviewData.date_available_tunnel_comment
        ? initialInterviewData.date_available_tunnel_comment
        : freelance.date_available_tunnel_comment,
      relocationLongFulltimeComment: initialInterviewData.relocation_long_fulltime_comment
        ? initialInterviewData.relocation_long_fulltime_comment
        : freelance.relocation_long_fulltime_comment,
      relocationLongFulltime: initialInterviewData.relocation_long_fulltime
        ? initialInterviewData.relocation_long_fulltime
        : freelance.relocation_long_fulltime,
      workPermit: initialInterviewData.work_permit
        ? initialInterviewData.work_permit
        : freelance.work_permit,
      situation: initialInterviewData.situation
        ? initialInterviewData.situation
        : freelance.situation,
      yearlyBrut: initialInterviewData.yearly_brut
        ? initialInterviewData.yearly_brut
        : freelance.yearly_brut,
      price: initialInterviewData.price
        ? initialInterviewData.price
        : freelance.price,
      city: initialInterviewData.city
        ? initialInterviewData.city
        : user.city && user.city.label,
      workCities: initialInterviewData.work_cities
        ? initialInterviewData.work_cities
        : userWorkCities,
      createdAt: initialInterviewData.created_at && initialInterviewData.created_at.date
        ? initialInterviewData.created_at.date
        : null,
      agent: initialInterviewData.agent && initialInterviewData.agent.firstname && initialInterviewData.agent.lastname
        ? initialInterviewData.agent.firstname + ' ' + initialInterviewData.agent.lastname
        : null,
    }
  }

  render() {
    const {freelance} = this.props
    const remark = (freelance && freelance.interview_remark)? freelance.interview_remark :  null
    const agentRemark = (freelance && freelance.agent_remark)? freelance.agent_remark :  null

    const data = this.getNoteData()

    return (
      <div className={"interview-note"}>
        <div className={'interview-note-header mb-2'}>
          Créé par <strong>{data.agent}</strong> {data.createdAt && <>le <strong><Date format="dd/MM/yyyy à HH:mm" date={data.createdAt}/></strong></>}
        </div>

        <h5>Informations</h5>
        <DivLeftAlign className={'bg-gray-100 p-4 rounded'}>
          <ul className="interview-details">
            <li>
              <strong>Disponible le : </strong>
              <Date date={data.dateAvailable}/>
            </li>
            <li>
              <strong>Commentaires : </strong>
              {data.dateAvailableTunnelComment}
            </li>
            <li>
              <strong>Autorisation de travail : </strong>
              {this.getFreelancePermit(data.workPermit)}
            </li>
            <li>
              <strong>Statut Professionnel : </strong>
              {this.getFreelanceSituation(data.situation)}
            </li>
            <li>
              <strong>Habite à : </strong>
              {data.city}
            </li>
            <li>
              <strong>Est prêt à travailler à : </strong>
              {data.workCities} {(data.relocationLongFulltime)? ` - Mobile France entière`: null}
            </li>
            <li>
              <strong>Commentaires : </strong>
              {data.relocationLongFulltimeComment}
            </li>
            <li>
              <strong>TJM/Equivalent brut : </strong>
              {data.price} / {data.yearlyBrut}
            </li>
          </ul>
        </DivLeftAlign>

        <h5>Notes et remarques</h5>
        <DivLeftAlign className={'interview-description bg-gray-100 p-4 rounded'} dangerouslySetInnerHTML={{__html: remark}}/>

        <h5>Appréciation de l'agent</h5>
        <DivLeftAlign className={'interview-description bg-gray-100 p-4 rounded'} dangerouslySetInnerHTML={{__html: agentRemark}}/></div>
    )
  }
}
